import styled from 'styled-components'

export const ResetCacheContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
`

export const Disclaimer = styled.p`
  font-style: italic;
  opacity: 0.7;
`
